
import * as actions from '../actionTypes'


const initialState = {
  errors: {invalidCredentials: false},
  isAuthorized: false,
  isRequestingAccess: false,
  isSessionVerified: false,
  user: {
    name: '',
    roles: []
  }
}

const authorization = (state = initialState, action) => {
  switch(action.type) {
    case actions.CLEAR_LOGIN_ERRORS:
      return {
        ...state,
        errors: {invalidCredentials: false}
      }
    case actions.LOGIN_FAILURE:
      return {
        ...state,
        errors: {invalidCredentials: true},
        isAuthorized: false,
        isRequestingAccess: false,
        user: {
          name: '',
          roles: []
        }
      }
    case actions.LOGIN_REQUESTED:
      return {...state, isRequestingAccess: true}
    case actions.LOGIN_SUCCESS:
      const {user} = action.payload
      return {
        ...state,
        errors: {invalidCredentials: false},
        isAuthorized: true,
        isRequestingAccess: false,
        user: {
          name: `${user.givenName} ${user.surname}`,
          roles: user.roles
        }
      }
    case actions.LOGOUT:
      return {
        ...state,
        errors: {...state.errors},
        isAuthorized: false,
        user: {
          name: '',
          roles: []
        }
      }
    case actions.SESSION_IS_ACTIVE:
      return {
        ...state,
        isAuthorized: true,
        isSessionVerified: true,
        user: action.payload.user
      }
    case actions.SESSION_IS_INACTIVE:
      return {
        ...state,
        isAuthorized: false,
        isSessionVerified: true,
        user: {
          name: '',
          roles: []
        }
      }
    case actions.UNAUTHORIZED_REQUEST:
      return {
        ...state,
        isAuthorized: false
    }
    default:
      return state
  }
}

export default authorization


// WEBPACK FOOTER //
// ./src/reducers/authorization.js